import * as React from 'react';
import {ChangeEvent} from 'react';
import {AppContext, AppContextType} from '../../AppContextType';
import {FilterOptions} from '../../Filter/FilterOptions';
import {Industry} from '../../Model/Industry';
import {JobCenterModelInterface} from '../../Model/JobCenterModelInterface';
import {Sector} from '../../Model/Sector';

interface SelectBoxProps<T> {
    models: JobCenterModelInterface[],
    valueId: string | number | undefined
    placeholder?: string
    onChange: (selection: T | undefined, event: ChangeEvent<HTMLSelectElement>) => void
}

interface SelectBoxState<T> {
    value: T | undefined;
}

export abstract class AbstractModelSelectBox<T extends Industry | Sector> extends React.Component<SelectBoxProps<T>, SelectBoxState<T>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: SelectBoxProps<T>, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            value: undefined
        };
    }

    public render() {
        const value = this.state.value;
        const options = this.getOptions();
        const className = 'job-center-filter-field job-center-filter-field-' + this.getOptionProperty().replace(
            '.',
            '-'
        );
        const props = this.props;
        const selectedValueIdFromProperties = props.valueId ? '' + props.valueId : undefined;
        const renderOption = (i: T) => <option key={i.referenceId} value={i.referenceId}>{i.name}</option>;

        return <div className={className}>
            <label>
                {this.renderLabel()}
                <select value={value ? value.referenceId : selectedValueIdFromProperties}
                        onChange={this.handleChange}>
                    <option>{props.placeholder || ''}</option>
                    {options.map(renderOption)}
                </select>
            </label>
        </div>;
    }

    protected abstract getOptionProperty(): string;

    protected abstract renderLabel(): JSX.Element;

    private getOptions(): T[] {
        return FilterOptions.collectOptions(this.props.models, this.getOptionProperty());
    }

    private handleChange(event: ChangeEvent<HTMLSelectElement>) {
        const selectedReferenceId = event.target.value;

        if (selectedReferenceId) {
            const selectedModel = this.getOptions().find(i => i.referenceId === selectedReferenceId);
            this.props.onChange(selectedModel, event);
        } else {
            this.props.onChange(undefined, event);
        }
    }
}
